import React, { useEffect, useRef, useState } from 'react';

import FiltersEntitiesPage from './FiltersEntitiesPage';
import EntityModal from './EntityModal';
import ConfirmationModal from '../Shared/Modals/ConfirmationModal';
import EntitiesTable from '../../components/Entities/EntitiesTable';
import { isCC } from '../../helpers';
import ConflictReportButton from './ConflictReportButton';
import { useEntitiesState, useFiltersDispatch, useFiltersState, useUserState } from '../../store/hooks';
import { ADD_ACTION, CONFIRMATION_MODAL_CONFIG, ENTITY_MODEL_TYPES, ENTITY_STATUS_TYPES, ENTITY_VALUES, FILTER_KEYS, NFL_GAME } from '../../config/constants';
import { useRouter } from '../../helpers/customHooks';
import { EntitiesBodyProps, Entity } from './types';
import { useEntitiesDispatch } from 'store/hooks/entities';

import './Entities.scss';
import Loader from 'components/Shared/Loader';

export default ({
                  teamId, drawerVisible, alertCount, // state
                  loadEntities, deleteEntity, createEntity, editEntity, // dispatch
                  computeRepeatedTags, setDrawerVisible, isToday
                } : EntitiesBodyProps) => {

  const { specificScope } = useRouter();
  const { entitiesObject, isDataOpsPage } = useEntitiesState();
  const { getEntities, deleteAllEntitiesTags } = useEntitiesDispatch();
  const user = useUserState();
  const {
    [FILTER_KEYS.TARGETED_RETRACK]: tRetrack = false,
    [FILTER_KEYS.LEAGUE]: league,
    [FILTER_KEYS.VENUE]:venue
  } = useFiltersState(specificScope, FILTER_KEYS.TARGETED_RETRACK, FILTER_KEYS.LEAGUE, FILTER_KEYS.VENUE);
  const isNFLGame =  league && league.name === NFL_GAME;
  const { loadTeams, changeFilterData } = useFiltersDispatch();

  const [editable, setEditable] = useState(false);
  const [modalShow, setModalShow] = useState(-1); // -1 nothing, 0 add/edit, 1 confirmation 2 all tags
  const [addMode, setAddMode] = useState(false);
  const [selectedEntity, setSelectedEntity] = useState<Entity|null>(null);
  const [players, setPlayers] = useState(0);
  const [balls, setBalls] = useState(0);
  const [tags, setTags] = useState(0);
  const [actPlayers, setActPlayers] = useState(0);
  const [actTagPlayers, setActTagPlayers] = useState(0);
  const selectedLeague = league?.value.value;
  const selectedType = league?.name;
  const rendersCounter = useRef(0);
  const [showMessg, setShowMessg] = useState(false);
  const [resetFilter, setResetFilter] = useState(false);
  useEffect(() => {
    loadTeams();
    rendersCounter.current++;
    if(rendersCounter.current > 1 || isDataOpsPage){
      setResetFilter(false);
      if(venue?.name === ''){
        setShowMessg(true);
      }else{
        setShowMessg(false);
      }
      isToday ? getEntities(teamId) : loadEntities();
    }else{
      setShowMessg(true);
      setResetFilter(true);
    }
  }, [venue]);
  
  useEffect(() => {
    const entities = entitiesObject ? Object.keys(entitiesObject).map(entityId => entitiesObject[entityId]) : [];
    let countPlayers = 0;
    let countBalls = 0;
    let countTags = 0;
    let countActPlayers = 0;
    let countActTagPlayers = 0;
    Object.keys(entities).forEach(entityId => {
      //@ts-ignore
      const entity = entities[entityId];
      if (entity !== '') {
        if (entity.model === ENTITY_VALUES.PLAYER) {
          countPlayers++;
          if (entity.extra_data.status === ENTITY_STATUS_TYPES.ACT) {
            countActPlayers++;
          }
          if (entity.extra_data.status === ENTITY_STATUS_TYPES.ACT && entity.tags.length > 1) {
            const tags = entity.tags;
            let tagRight: boolean = false;
            let tagLeft: boolean = false;
            tags.forEach((element: any) => {
              if(element && element.name && element.name.includes('left')){
                tagLeft = true;
              }
              if(element && element.name && element.name.includes('right') ){
                tagRight = true;
              }
            });
            if(tagLeft && tagRight){
              countActTagPlayers++;
            }
          }
        } else if (entity.model === ENTITY_MODEL_TYPES.GAME_BALL) {
          countBalls++;
        }
        countTags += entity.tags.length;
      }
    });
    setPlayers(countPlayers);
    setBalls(countBalls);
    setActPlayers(countActPlayers);
    setActTagPlayers(countActTagPlayers);
    setTags(countTags);
    return () => {
      setPlayers(0);
      setBalls(0);
      setActPlayers(0);
      setTags(0);
    };
  }, [entitiesObject]);
  // caller is the button who calls fn.
  // code yet to be added
  const handleModalClick = (caller:string, entity:Entity | null = null) => {
    if (caller === ADD_ACTION) {
      setSelectedEntity(null);
      setAddMode(true);
    } else {
      setAddMode(false);
      if (entity) {
        setSelectedEntity(entity);
      }
    }
    setModalShow(0);
  };

  const modalClose = () => {
    setModalShow(-1);
    setSelectedEntity(null);
    setAddMode(false);
  };

  const openConfirmationModal = (entity:Entity|null) => {
    setModalShow(1);
    setSelectedEntity(entity);
  };
    const openTagsConfirmationModal = () => {
    setModalShow(2);
  };

  const handleDeleteConfirmation = () => deleteEntity(selectedEntity as Entity);

  const handleDeleteAllTagsConfirmation = () => deleteAllEntitiesTags(teamId);

  const confirmationModalContent = {
    headerContent: ' ',
    bodyContent: 'Are you sure you want to delete this entity from the Entity Server?',
    confirmContent: 'Yes, Delete Entity'
  };

    const delteAllTagsConfirmationModal = {
    headerContent: ' ',
    bodyContent: 'Are you sure you want to delete all entities tags from the Entity Server?',
    confirmContent: 'Yes, Delete All Tags'
  };

  const onModalExited = () => setSelectedEntity(null);

  const reloadEntities = () => {
    if (editable) {
      setEditable(false);
    }
    if (setDrawerVisible) {
      setDrawerVisible(undefined); // resetting drawer to it's initial state because of reload
    }
    loadEntities();
  };

  return <>
    <EntityModal
      isToday={isToday}
      show={modalShow} onHide={modalClose} addMode={addMode}
      selectedEntity={selectedEntity as Entity} teamId={teamId} createEntity={createEntity}
      editEntity={editEntity} onExited={onModalExited}
    />
    <ConfirmationModal
      show={modalShow || modalShow === 2} onHide={modalClose} modalConfig={CONFIRMATION_MODAL_CONFIG}
      modalContent={modalShow === 2? delteAllTagsConfirmationModal  :confirmationModalContent}
      confirmAction={modalShow === 2? handleDeleteAllTagsConfirmation : handleDeleteConfirmation}
    />
    <div className="entities-ff">
      {(!isDataOpsPage && isCC(user)) && <div style={editable? {opacity: 0.5, cursor: 'default', pointerEvents: 'none'}: {}}> 
        <FiltersEntitiesPage loadData={loadEntities} showMessg={resetFilter} specificScope={specificScope}/> 
        </div>}
      {isDataOpsPage &&
        <div className="keep-00">
          <label className="ww-ee">
            <input
              className="styled-checkbox"
              id="styled-checkbox-tretrack"
              type="checkbox"
              value="value2"
              checked={tRetrack}
              onChange={ changeFilterData(!tRetrack, FILTER_KEYS.TARGETED_RETRACK, specificScope) }
            />
            <label htmlFor="styled-checkbox-tretrack" className="check-l" />
          </label>
          <b>Targeted Retrack</b>
        </div>}
      <div className="title-009">Selected Filter Information:</div>
      <div className="cont-e"><b>Total Players:</b> {players}  </div>
      <div className="cont-e"><b>ACT Players:</b> {actPlayers}</div>
      <div className="cont-e"><b>Tagged ACT Players:</b> {actTagPlayers}</div>
      <div className="cont-e"><b>Total Tags:</b> {tags} </div>
      <div className="cont-e"><b>Game Balls:</b> {balls}</div>
      <div className="entities-btn">

        {!isDataOpsPage &&
        <div className="switch-00" style={{ display: 'inline-block', marginRight: '40px', padding: '2.5px 0px' }}>
          <input
            type="checkbox" id="undefined-all-selected" name="set-name" className="switch-input"
            checked={editable}
            onChange={() => setEditable(!editable)}
            disabled={showMessg}
          />
          <label htmlFor="undefined-all-selected" id="undefined-all-selected-label" className="switch-label" />
        </div>}
        <button style={showMessg ? { opacity: 0.9, cursor: 'default', pointerEvents: 'none' } : {}}
         disabled={showMessg} onClick={reloadEntities} className="btn-lo"><i className="mdi mdi-refresh" /></button>
        {isNFLGame && !showMessg && <ConflictReportButton teamId={teamId} />}
        <button className="btn-blue" disabled={showMessg} 
        style={showMessg ? { opacity: 0.5, cursor: 'default', pointerEvents: 'none', color: '#FFFFFF' } : {}} onClick={() => handleModalClick(ADD_ACTION)}>Add Entity</button>
      </div>
    </div>
    <div className={`profiles-body-00 entities-f ${isDataOpsPage ? `adjust-height-entities-dataops-body` : `adjust-height-entities-body`}`}>
      {isDataOpsPage ?
      <Loader>
      <EntitiesTable
        league={selectedLeague}
        isToday={isToday}
        modalOpener={handleModalClick}
        editable={editable}
        openConfirmationModal={openConfirmationModal}
        computeRepeatedTags={computeRepeatedTags}
        editEntity={editEntity}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        alertCount={alertCount}
      />
      </Loader>
      :
        showMessg ? 
        <>
        <Loader forceMessage='Please select a Team to see the Roster'/>
        </>
        : 
      <EntitiesTable
        league={selectedLeague}
        leagueType={selectedType}
        isToday={isToday}
        modalOpener={handleModalClick}
        editable={editable}
        openConfirmationModal={openConfirmationModal}
        openTagsConfirmationModal={openTagsConfirmationModal}
        computeRepeatedTags={computeRepeatedTags}
        editEntity={editEntity}
        drawerVisible={drawerVisible}
        setDrawerVisible={setDrawerVisible}
        alertCount={alertCount}
      />
      }
    </div>
  </>;
};
